/**
 * Centralized locale cookie management
 * Uses NEXT_LOCALE to match next-intl standard and ensure compatibility with Landing app
 */

export const LOCALE_COOKIE_NAME = 'NEXT_LOCALE';

/**
 * Get cookie domain based on environment
 * For production with subdomains (getfacade.test, app.getfacade.test), use .getfacade.test
 * For localhost, don't set domain (cookies work across ports by default)
 */
function getCookieDomain(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const hostname = window.location.hostname;

  // For localhost, don't set domain (works across all ports)
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return undefined;
  }

  // For production domains, extract base domain
  // getfacade.test or app.getfacade.test -> .getfacade.test
  const parts = hostname.split('.');
  if (parts.length >= 2) {
    return `.${parts.slice(-2).join('.')}`;
  }

  return undefined;
}

/**
 * Set locale cookie with proper domain handling
 */
export function setLocaleCookie(locale: string): void {
  const domain = getCookieDomain();
  const domainPart = domain ? `; domain=${domain}` : '';

  document.cookie = `${LOCALE_COOKIE_NAME}=${locale}; path=/; max-age=31536000; SameSite=Lax${domainPart}`;
}

/**
 * Get locale from cookie
 */
export function getLocaleCookie(): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const value = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${LOCALE_COOKIE_NAME}=`))
    ?.split('=')[1];

  return value || null;
}
